import { ethers } from 'ethers';
import { type IExpedition } from 'public/abi/evm/types/Expedition';
import type { HalloweenLocation } from '~/types/halloween/location';

export interface RawStatefulLog extends IExpedition.ExpeditionIntermediateStateStructOutput {
  index: number;
  location: HalloweenLocation;
  uniqueEventIndex: string;
}

export default function createRawStatefulLog(
  rawLog: IExpedition.ExpeditionIntermediateStateStructOutput,
  index: number,
  locationId: string
) {
  return {
    eventVariation: rawLog.eventVariation,
    eventTime: rawLog.eventTime,
    aliveCharacters: rawLog.aliveCharacters,
    deadCharacters: rawLog.deadCharacters,
    status: rawLog.status,
    index,
    location: (locationId === ethers.keccak256(ethers.toUtf8Bytes('forest')) ? 'forest' : 'cave') as HalloweenLocation,
    uniqueEventIndex: locationId + rawLog.eventVariation + rawLog.eventTime
  } as RawStatefulLog;
}
